module.exports = __webpack_public_path__ + "static/media/parallax2.42b57180.jpg";